import React, { useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BottomBar from "components/bottom-bar";
import { useCreateInStoreShipping } from "api/tes/useCreateInStoreShipping";
import AuthContext from "contexts/AuthContext";

export default function CreatingShippingLabel() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const { authTokens } = useContext(AuthContext);
  const { weight, uom, type, store_location } = location.state || {};
  const hasStartedRef = useRef(false);

  // Get current language for navigation
  const currentLang = i18n.language === "de" ? "de-DE" : "en-US";

  const createInStoreShipping = useCreateInStoreShipping({
    onSuccess: (data) => {
      // Navigate to print shipping label page with the label URL
      if (data.success && data.data && data.data.length > 0) {
        const shippingData = data.data[0];
        const originalLabelUrl = shippingData?.shipping_metadatas?.items?.find(
          (item) => item.key === "label_url"
        )?.value;

        if (originalLabelUrl) {
          try {
            const url = new URL(originalLabelUrl);
            const returnID = url.searchParams.get("returnID");

            let labelUrl = originalLabelUrl;
            if (returnID) {
              // Construct the PDF URL similar to the dropoff flow
              labelUrl = `${window.location.origin}/api/pdf/shipping-label-no-instructions?returnID=${returnID}&token=${authTokens?.access_token || ""}`;
            }

            navigate(`/${currentLang}/store/print-shipping-label`, {
              state: { labelUrl },
            });
          } catch (error) {
            console.error("Error constructing label URL:", error);
            navigate(`/${currentLang}/store/print-shipping-label`, {
              state: { labelUrl: originalLabelUrl },
            });
          }
        } else {
          alert(
            "Shipping label generated, but no URL found. Please check the shipping status."
          );
          navigate(`/${currentLang}/store/shipping`);
        }
      } else {
        alert(
          "Shipping label generated successfully, but no tracking data returned."
        );
        navigate("/store/shipping");
      }
    },
    onError: (error) => {
      alert(`Failed to create shipping label: ${error.message}`);
      navigate("/store/shipping");
    },
  });

  useEffect(() => {
    // If we don't have the required data, redirect back to shipping
    if (!weight || !store_location) {
      navigate(`/${currentLang}/store/shipping`);
      return;
    }

    // Only start the API call if we haven't already
    if (!hasStartedRef.current) {
      hasStartedRef.current = true;
      createInStoreShipping.mutate({
        weight,
        uom,
        type,
        store_location,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weight, uom, type, store_location, navigate, currentLang]);

  return (
    <div className="flex flex-col h-[calc(100vh-81px)]">
      <div className="flex flex-grow flex-col items-center justify-center px-6 py-4 text-center">
        <h1 className="text-4xl font-semibold text-gray-900 mb-4">
          Creating shipping label
        </h1>
      </div>
      <BottomBar />
    </div>
  );
}
